import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/tooltip';
import { Check, Circle, X } from 'lucide-react';

export type MatrixCellState =
  | { kind: 'pass'; tooltip: string }
  | { kind: 'fail'; tooltip: string }
  | { kind: 'optional-set'; tooltip: string }
  | { kind: 'optional-missing'; tooltip: string }
  | { kind: 'na' };

export default function MatrixCell({ state }: { state: MatrixCellState }) {
  if (state.kind === 'na') {
    return (
      <span className="text-zinc-400" aria-label="Not applicable">
        —
      </span>
    );
  }

  const visual = (() => {
    switch (state.kind) {
      case 'pass':
        return {
          icon: <Check className="size-4 text-emerald-600" />,
          label: 'Pass',
        };
      case 'fail':
        return {
          icon: <X className="size-4 text-red-600" />,
          label: 'Fail',
        };
      case 'optional-set':
        return {
          icon: <Check className="size-4 text-zinc-400" />,
          label: 'Set',
        };
      case 'optional-missing':
        return {
          icon: <Circle className="size-3.5 text-zinc-300" />,
          label: 'Empty',
        };
    }
  })();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className="inline-flex items-center justify-center"
          aria-label={visual.label}
        >
          {visual.icon}
        </span>
      </TooltipTrigger>
      <TooltipContent side="top">{state.tooltip}</TooltipContent>
    </Tooltip>
  );
}
